import React from 'react';

import { Box, Stack, Text, Title, UnstyledButton } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { useGLMCardStyles } from '../styles';
import { ATHLETE_STATUSES, GLMKiloFormValues } from '../types';

interface IGLMKiloActionConfigProps {
  form: UseFormReturnType<GLMKiloFormValues, (values: GLMKiloFormValues) => GLMKiloFormValues>;
}

const GLMKiloActionConfig = ({ form }: IGLMKiloActionConfigProps): JSX.Element => {
  const { classes, cx } = useGLMCardStyles();

  return (
    <Stack sx={{ paddingTop: '20px' }}>
      <Title order={3}>Set athlete status</Title>
      <Text size={15}>After linking, the Kilo athlete will be set to this status.</Text>
      <Stack spacing={6}>
        {ATHLETE_STATUSES.map(status => {
          const isSelected = form.values.acAthleteStatus === status;
          return (
            <UnstyledButton key={status} onClick={() => form.setFieldValue('acAthleteStatus', status)}>
              <Box className={cx(classes.card, { [classes.cardSelected]: isSelected })}>
                <Text weight={isSelected ? 600 : 400}>{status}</Text>
              </Box>
            </UnstyledButton>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default GLMKiloActionConfig;
